import React from 'react';
import { useDispatch } from 'react-redux';
import { BackupDetails, MopCheckbox, MopCheckboxWrapper } from './styled';
import { getString } from '../../../constants/Strings';
import { DataTestAttributes } from '../../../constants/DataTestAttributes';
import { saveConfigs } from '../../../redux/ConfigState/ConfigState.actions';
export var MopCheckboxSection = function MopCheckboxSection(props) {
  var dispatch = useDispatch();
  var isPrimary = props.isPrimary,
    isBackup = props.isBackup,
    isMultipleMop = props.isMultipleMop,
    isDefaultChecked = props.isDefaultChecked,
    isBackUpChecked = props.isBackUpChecked,
    setIsDefaultChecked = props.setIsDefaultChecked,
    setIsBackUpChecked = props.setIsBackUpChecked;

  // Checkboxes are disabled when user has only 1 MOP on file or if default/backup is initially checked
  var isDefaultDisabled = !isMultipleMop || isPrimary;
  var isBackUpDisabled = !isMultipleMop || isBackup;
  var defaultDescription = isPrimary ? 'APP.MOPONFILE.DEFAULT' : 'APP.MOPONFILE.MAKE_DEFAULT';
  var backupDescription = isBackup ? 'APP.MOPONFILE.BACKUP' : 'APP.MOPONFILE.MAKE_BACKUP';
  var onDefaultCheckboxClick = function onDefaultCheckboxClick(e) {
    var isChecked = e.target.checked;
    setIsDefaultChecked(isChecked);
    if (isChecked && !isBackUpDisabled) {
      // allows single-select; only 1 checkbox can be checked at any time
      setIsBackUpChecked(false);
    }
    dispatch(saveConfigs({
      isCheckboxUpdated: true
    }));
  };
  var onBackupCheckboxClick = function onBackupCheckboxClick(e) {
    var isChecked = e.target.checked;
    setIsBackUpChecked(isChecked);
    if (isChecked && !isDefaultDisabled) {
      // allows single-select; only 1 checkbox can be checked at any time
      setIsDefaultChecked(false);
    }
    dispatch(saveConfigs({
      isCheckboxUpdated: true
    }));
  };
  return /*#__PURE__*/React.createElement(MopCheckbox, {
    "data-test": DataTestAttributes.CHECKBOX_CONTAINER
  }, /*#__PURE__*/React.createElement(MopCheckboxWrapper, {
    className: 'make-default-checkbox',
    "data-test": DataTestAttributes.UPDATE_MOP_MAKE_DEFAULT_CHECKBOX,
    type: "checkbox",
    size: "large",
    checked: isDefaultChecked,
    disabled: isDefaultDisabled,
    onChange: onDefaultCheckboxClick,
    inputId: 'default-payment-method--checkbox'
  }, getString(defaultDescription)), /*#__PURE__*/React.createElement(MopCheckboxWrapper, {
    "data-test": DataTestAttributes.MAKE_BACKUP_CHECKBOX,
    type: "checkbox",
    size: "large",
    checked: isBackUpChecked,
    disabled: isBackUpDisabled,
    onChange: onBackupCheckboxClick,
    inputId: 'backup-payment-method--checkbox'
  }, getString(backupDescription)), /*#__PURE__*/React.createElement(BackupDetails, {
    isDisabled: isBackUpDisabled
  }, getString('APP.MOPONFILE.BACKUP.DETAILS')));
};
export default /*#__PURE__*/React.memo(MopCheckboxSection);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/MopListView/MopCheckboxSection.js
// module id = 4643
// module chunks = 11